export default {"src":"/_next/static/media/fail.94ac1b18.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};